import api from '../../Shared/Services/api';

const isReactIntlErrors = (...args) => {
  // you can use ?showIntlErrors in your url to re-enable these
  if (args && args.length) {
    return (
      args.findIndex(arg => {
        arg = arg.toString();
        return (
          arg.indexOf('[React Intl]') !== -1 &&
          window.location.search.toLowerCase().indexOf('showintlerrors') === -1
        );
      }) > -1
    );
  }
  return false;
};

const logEvent = (eventLevel = 'error', args) => {
  //swallow all react intl errors
  if (isReactIntlErrors(args)) {
    return;
  }

  try {
    if (window.App && window.App.user && window.App.user.id) {
      if (eventLevel === 'error' || eventLevel === 'warn') {
        api.postJson('/ClientError', {
          name: 'ClientEvent',
          data: {
            PageRequestId: (window.App && window.App.requestId) || 'console',
            PagePath: window.location.pathname,
            EventArguments: args,
            EventLevel: eventLevel === 'warn' ? 'Warn' : 'Error',
          },
        });
      }
    }
  } finally {
    if (window.devConsole && process.env.NODE_ENV !== 'production') {
      window.devConsole[eventLevel](...args);
    }
  }
};

export const log = (...args) => {
  logEvent('log', args);
};

export const logWarn = (...args) => {
  logEvent('warn', args);
};

export const logError = (...args) => {
  logEvent('error', args);
};

export const activateLogger = () => {
  window.devConsole = window.console;
  window.console = {
    log: (...args) => log(...args),
    warn: (...args) => logWarn(...args),
    error: (...args) => logError(...args),
  };
};

export const deactivateLogger = () => {
  if (window.devConsole) {
    window.console = window.devConsole;
    delete window.devConsole;
  }
};

export default { log, logWarn, logError, activateLogger, deactivateLogger };



// WEBPACK FOOTER //
// ./src/Shared/UIEventLogger/UIEventLogger.js